import { useRef } from "react";
import Logo from "assets/logo/logo_morning.png";
// import Print from "assets/morning/Print-v2.png";
import Print from "assets/morning/Print-v3.png";
import { QRCodeSVG } from "qrcode.react";
import loadImage from "../../../../assets/common/common/call.png";

interface Props {
    data: any;
    onClose: () => void;
}

const PrintA4Preview = ({ data, onClose }: Props) => {
    const loadedCountRef = useRef(0);
    // const validData = data.filter((item: any) => Object.keys(item).length > 0);

    const handleImageLoad = () => {
        loadedCountRef.current += 1;
        // 프린트 로직은 제거하고 이미지 로딩만 처리
    };

    return (
        <div id="print-a4-preview" className="print-a4 pl-0.5">
            {data[0].map((item: any, index: any) => {
                const isEmpty = Object.keys(item).length === 0;
                const isSendManager = item?.보내는담당자;
                const isSendPhoneNoManager = !isSendManager && item?.보내는핸드폰번호;

                return (
                    <div key={index}>
                        {isEmpty ? (
                            <div className="w-full h-[330px] mb-7 flex items-center justify-center text-gray-400 text-sm" />
                        ) : (
                            <div className="relative h-[330px] w-[850px] mb-7 rounded-xl overflow-hidden">
                                <div className="grid w-full h-[330px] min-w-[850px]">
                                    <img src={Print} alt="배경" className="w-full h-[330px] object-cover row-start-1 col-start-1" />
                                    <div className="z-10 row-start-1 h-[330px] col-start-1 flex border-[8px] rounded-[12px] border-[#132E47]">
                                        <div className="flex flex-col w-[38%] min-w-[38%] max-w-[38%] overflow-hidden">
                                            <div className="pr-7 px-2 pt-0.5">
                                                <img className="w-auto h-[35px]" src={Logo} alt="Logo" />
                                                <p className="text-[7px] text-[#666]">www.morning.ilshingroup.com</p>
                                            </div>
                                            <p className="text-[18px] pr-7 font-bold pb-1 mt-[14px]">
                                                <span className="text-[15px] text-[#333D5C] font-normal min-w-[96px] inline-block"></span>
                                                <span className="min-h-[16px] inline-block">
                                                    {item?.접수일자 ? item.접수일자 : <>&nbsp;</>}
                                                </span>
                                            </p>
                                            <p className="text-[18px] pr-7 font-bold pt-0.5 pb-3 whitespace-nowrap mt-1">
                                                <span className="text-[15px] text-[#333D5C] font-normal min-w-[96px] inline-block"></span>
                                                <span>{item.B_L번호}</span>
                                            </p>
                                            <p className="text-[18px] font-bold pt-1.5 mt-2 pb-3">
                                                <span className="text-[15px] text-[#333D5C] font-normal min-w-[96px] inline-block"></span>
                                                <span>1566-0685</span>
                                            </p>
                                            <div className="flex">
                                                <div className="p-2 flex flex-col min-w-[140px]">
                                                    <p className="mt-[-2px] ml-[14px] self-end pr-[10px]">{item.담당자명 ?? "-"}</p>
                                                    <div className="flex justify-center">
                                                        <QRCodeSVG value={item.B_L번호} width={66} height={66} className="mt-3" />
                                                    </div>

                                                    <img src={loadImage} alt="" onLoad={handleImageLoad} className="w-0 h-0 absolute" />
                                                    <img src={loadImage} alt="" onLoad={handleImageLoad} className="w-0 h-0 absolute" />

                                                    {/* <img
                                                        onLoad={handleImageLoad}
                                                        onError={handleImageLoad}
                                                        loading="eager"
                                                        className="mt-3 mr-5 shrink-0"
                                                        src={item.QR66x66 || ""}
                                                        alt="QR66x66"
                                                        width={66}
                                                        height={66}
                                                    /> */}
                                                </div>
                                                <div className="p-2 w-[60%] min-w-[60%] max-w-[60%]">
                                                    <p className="mt-[15px] break-keep whitespace-wrap">{item.요청사항}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex flex-col w-full pl-1">
                                            <div className="flex">
                                                <div className="flex flex-col w-full">
                                                    <div className="flex -mt-2">
                                                        <p className="w-[86px] h-[55px] font-bold text-5xl flex items-center justify-center">
                                                            {item?.센터코드}
                                                        </p>
                                                        <p className="h-[55px] min-w-60 ml-11 font-bold text-3xl flex items-center">
                                                            {item?.센터명}
                                                        </p>
                                                        <div className="absolute top-5 right-11">
                                                            <QRCodeSVG value={item.B_L번호} width={66} height={66} />

                                                            {/* <img
                                                                onLoad={handleImageLoad}
                                                                onError={handleImageLoad}
                                                                loading="eager"
                                                                className="mt-7 mr-5 shrink-0"
                                                                src={item.QR66x66 || ""}
                                                                alt="QR66x66"
                                                                width={66}
                                                                height={66}
                                                            /> */}
                                                        </div>
                                                    </div>
                                                    <div className="flex h-12">
                                                        <div className="flex h-12">
                                                            <p className="w-[200px] pl-7 flex items-center font-bold">{item?.운임}</p>
                                                        </div>
                                                        <div className="flex">
                                                            <p className="ml-7 flex items-center font-bold ">{item?.수량}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex ml-1 h-[90px]">
                                                <div className="flex flex-col mt-2 justify-center pl-5 min-h-[64px]">
                                                    <p className="font-bold leading-[16px] overflow-hidden">
                                                        {item?.보내는상호} {item?.보내는전화번호}
                                                    </p>
                                                    <p className="text-[13px] tracking-[0.8] leading-[14px] mt-[2px]">
                                                        {item?.보내는주소1} {item?.보내는주소2}{" "}
                                                        {item?.보내는담당자 && `/ 담당자 ${item.보내는담당자}`}
                                                        {isSendPhoneNoManager && "/ "} {item?.보내는핸드폰번호}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="flex mt-3 ml-1">
                                                <div className="font-bold w-full rounded-br-xl flex flex-col pl-5 justify-center">
                                                    <p className="text-xl">{item?.받는상호}</p>
                                                    <p className="">{item?.받는전화번호}</p>
                                                    <p>
                                                        {item?.받는주소1}
                                                        {item?.받는주소2}
                                                    </p>
                                                    <p>
                                                        {item?.받는담당자 && `담당자 ${item?.받는담당자}`}
                                                        {item?.받는담당자 && item?.받는핸드폰번호 && "/ "}
                                                        {item?.받는핸드폰번호}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};
export default PrintA4Preview;
